// This file is AUTOGENERATED, do not edit it manually!!!

export const koPeopleTemplates = {
    nomatch_text: 'Подходящих условий не найдено',
    roles: 'Роли',
    teams: 'Команды',
    users: 'Пользователи',
};
